import { TEXT_ALIGNMENT } from 'constants/fonts';
import { AccessibleElement, Widget } from 'types/widget.types';

interface FormProps {
  inputFocus?: boolean;
  labelFocus?: boolean;
  clickSource?: string;
  setWidgetState?: (state: any) => void;
  isReadOnly?: boolean;
}

enum FontWeightOption {
  Normal = 'normal',
  Bold = 'bold',
}

enum TextDecorationOption {
  None = 'none',
  Underline = 'underline',
}

enum FontStyleOption {
  Normal = 'normal',
  Italic = 'italic',
}

enum LabelAlignment {
  start = 'start',
  center = 'center',
  end = 'end',
}

enum LabelPosition {
  Top = 'top',
  Left = 'left',
}

enum FormType {
  ShortQuestion = 'Short question',
}

enum InputType {
  Text = 'text',
  Email = 'email',
  Password = 'password',
  Date = 'date',
  Number = 'number',
}

type FormStyle = {
  lineHeight: string;
  fontWeight: FontWeightOption;
  fontStyle: FontStyleOption;
  textDecoration: TextDecorationOption;
  fontSize: number;
  fontFamily: string;
  textAlign: TEXT_ALIGNMENT;
  alignSelf: LabelAlignment;
  color: string;

  backgroundColor: string;
  borderRadius: number;
  borderColor: string;
  borderWidth: number;

  gap: number;
};

type FormField = {
  label: string;
  type: string;
  value: string;
  placeholder: string;
};

interface FormWidgetData extends Widget, AccessibleElement {
  type: FormType;
  style: FormStyle;
  submitButtonLabel: string;
  field: FormField;
  labelPosition: LabelPosition;
}

export type { FormWidgetData, FormProps, FormStyle, FormField };
export { LabelAlignment, LabelPosition, FormType, InputType, FontWeightOption, FontStyleOption, TextDecorationOption };
